/* eslint-disable @typescript-eslint/dot-notation */
import * as linear from '@/ui/icons/linear';
import * as solid from '@/ui/icons/solid';
import { IconSVG } from '@/ui/icons/types';
import cn from 'classnames';
import { IconProps } from './Icon.types';

import s from './Icon.module.css';

const Icon = ({
  name,
  variant,
  size = 24,
  color = 'iris-500',
  className = null,
  style,
  onClick,
}: IconProps) => {
  const IconComponent = (
    variant === 'solid' ? solid[name as keyof typeof solid] : linear[name as keyof typeof linear]
  ) as React.ElementType<IconSVG>;

  return (
    <span className={cn(s.icon, className)} onClick={onClick} aria-hidden>
      <IconComponent
        size={size}
        style={{
          fill: `var(--colors-${color})`,
          color: `var(--colors-${color})`,
          ...style,
        }}
      />
    </span>
  );
};

export default Icon;
